/**
 * ReportsHarvestInspectionPestDefectPercentage
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    pestDefectPercentage?: ?number;
}

export class ReportsHarvestInspectionPestDefectPercentage extends React.PureComponent<Props> {
    render() {
        const { pestDefectPercentage } = this.props;
        if (!pestDefectPercentage && pestDefectPercentage !== 0) return null;
        return `${pestDefectPercentage}%`;
    }
}

const mapStateToProps = createStructuredSelector({
    pestDefectPercentage: makeSelectReportsHarvestInspectionValue(
        'pestDefectPercentage'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionPestDefectPercentage
);
